<template>
    <j-page class="field-config-layout">
        <div slot="search">
            <el-button icon="el-icon-folder-add" type="info" @click="addDgmxEvent">创建自定义字段</el-button>
            <el-button icon="el-icon-delete" type="info" @click="batchDelEvent">移除字段</el-button>
        </div>
        <div slot="table">
            <el-table :cell-class-name="hideCheckBox" v-loading="tableLoading" :data="tableData" @selection-change="tableSelectionChange" height="100%" stripe>
                <el-table-column :selectable='isDisabled' type="selection"  width="50" />
                <el-table-column type="index" label="序号"  width="50" />
                <el-table-column prop="fieldName" label="字段名称"  show-overflow-tooltip />
                <el-table-column prop="fieldDesc" label="备注"  width="400" show-overflow-tooltip />
<!--                <el-table-column prop="fieldOrigin" label="字段类别"  show-overflow-tooltip>-->
<!--                    <j-dictionary slot-scope="{ row }" code="CONDIG_FIELD_ORIGIN" :value="row.fieldOrigin" />-->
<!--                </el-table-column>-->
                <el-table-column label="操作" width="140">
                    <template v-if="row.fieldOrigin != 1" slot-scope="{ row }">
                        <el-button @click.stop="editDgmxEvent(row)" type="text" class="common-button-edit">编辑</el-button>
                        <el-button @click.stop="delEvent(row)" type="text" class="common-button-del" >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!--        新增-->
        <el-dialog v-if="showDgmx" :title="dgmxTypeMap[dgmxType]" :visible.sync="showDgmx" width="400px" :close-on-click-modal="false" append-to-body>
            <el-form ref="dgmxDom" :model="dgmxForm" :rules="dgmxRule" :label-width="dgmxFormLabelWidth" @keydown.native.enter="checkDgmxEvent('saveDgmxData')">
                <el-form-item label="字段名称" prop="fieldName">
                    <el-input v-model.trim="dgmxForm.fieldName" placeholder="请输入字段名称" maxlength="100" show-word-limit clearable />
                </el-form-item>
                <el-form-item label="备注" prop="fieldDesc">
                    <el-input v-model.trim="dgmxForm.fieldDesc" type="textarea" :rows="3" placeholder="请输入备注" maxlength="100" show-word-limit clearable />
                </el-form-item>
            </el-form>
            <template slot="footer">
                <el-button type="primary" @click="checkDgmxEvent('saveDgmxData')" :loading="submitLoad">保存</el-button>
                <el-button type="info" @click="showDgmx = false">取消</el-button>
            </template>
        </el-dialog>
    </j-page>
</template>

<script>
    import PageMixins from "../../../../components/JComponents/JPage/mixins/PageMixins";
    import DialogMixins from "../../../../components/JComponents/JPage/mixins/DialogMixins";
    export default {
        name: "fieldConfig",
        mixins: [PageMixins, DialogMixins],
        props: ['meta'],
        data () {
            return {
                dgmxTypeMap: {
                    'ADD': '新增字段',
                    'EDIT': '编辑字段'
                },
                dgmxForm: {
                    fieldOrigin: 2,
                    fieldName: '',
                    fieldDesc: ''
                },
                dgmxRule: {
                    fieldName: [{ required: true, message: '请输入字段名称', trigger: 'blur' }]
                }
            }
        },
        created () {
          this.load()
        },
        methods: {
            hideCheckBox (row) {
                if (row.row.fieldOrigin == '1') return 'check-box-hide'
            },
            isDisabled (row) {
                if (row.fieldOrigin == '1') return 0
                return 1
            },
            async load () {
                this.tableLoading = true
                const { data } = await this.$http.get(`/api/fieldModels/${this.meta.ledgerId}/listFieldsAll`)
                this.tableData = data.data
                this.tableLoading = false
            },
            async saveDgmxData () {
                if (this.submitLoad) return
                this.submitLoad = true
                let method = 'post'
                let url = `/api/fieldModels/${this.meta.ledgerId}/addCustomField`
                if (this.dgmxType === 'EDIT') {
                    url = `/api/fieldModels/${this.meta.ledgerId}/updateCustomField`
                    method = 'put'
                }
                const { data } = await this.$http[method](url, this.dgmxForm)
                    .catch(({response}) => { this.$message.error(response.data.msg) })
                    .finally(() => { this.submitLoad = false })
                if (data.status !== 'yes') return this.$message.error(data.msg)
                this.showDgmx = false
                this.$message.success('提交成功')
                this.load()
            },
            async batchDelEvent () {
                if (this.tableSelection.length < 1) return this.$message.warning('请选择要移除的字段')
                const { data } = await this.$http.delete(`/api/fieldModels/${this.meta.ledgerId}/delCustomField`, {
                    params: { fieldModelIds: this.tableSelection.map(item => item.fieldModelId).join(',') }
                })
                if (data.status !== 'yes') return this.$message.error(data.msg)
                this.$message.success('删除成功')
                this.load()
            },
            delEvent (row) {
                this.$confirm('您确认要删除当前记录吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http
                        .request({
                            method: 'delete',
                            url: `/api/fieldModels/${this.meta.ledgerId}/delCustomField/${row.fieldModelId}`
                        })
                        .then((res) => {
                            if (res.data.status !== 'yes') return this.$message.error(res.data.msg)
                            this.$message.success('删除成功')
                            this.load && this.load()
                        })
                })
            }
        }
    }
</script>

<style lang="scss">
    .field-config-layout {
        .check-box-hide .el-checkbox__input {
            visibility: hidden;
        }
    }
</style>
